import { render, staticRenderFns } from "./editQuestion.vue?vue&type=template&id=49a2a834&scoped=true&"
import script from "./editQuestion.vue?vue&type=script&lang=js&"
export * from "./editQuestion.vue?vue&type=script&lang=js&"
import style0 from "./editQuestion.vue?vue&type=style&index=0&id=49a2a834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a2a834",
  null
  
)

export default component.exports